'use strict';

window.jQuery = window.$ = require('jquery');
require('popper.js');
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/popover';

import './components/jquery.tscroller';
// import './components/breadcrumbs';
// import './components/home-partner-slider';
// import './components/home-experts-slider';
import './components/ie10-viewport-bug';
import './components/offcanvas';
// import './components/home-service-list';
import './components/pg-nav-scrollspy';
import './components/main';
// import './components/show-less';
import './components/collapse-list';
import './components/expand-table';
import './components/table-modal';
import './elements/ServiceCalculator';
import './components/open-dropdown-mobile';
import './components/home-interests-swiper';
import './components/simplebar-test';
import './components/redesign-accordion';
import './components/redesign-scrolling';
import './components/redesign-select';
import './components/redesign-show-more';
import './front-page-search/index';


jQuery('#tscroller').tscroller();

$('.shortened').click(function () {
    $(this).toggleClass('d-none');
    $(this).toggleClass('d-inline');

    $(this).siblings('span').toggleClass('d-none');
    $(this).siblings('span').toggleClass('d-inline');
});

/**
 * Navigation
 */
$('span.nav-item').click(function () {
    let selectedItem = '#' + $(this).attr('data')

    if ($(selectedItem).hasClass('active')) {
        $(this).removeClass('active')
        $(selectedItem).removeClass('active')
        $('.overlay').removeClass('d-block')
    } else {
        $('.dropdown').removeClass('active')
        $('.nav-item').removeClass('active')
        $(this).addClass('active')
        $(selectedItem).addClass('active')
        $('.overlay').addClass('d-block')
    }
})

$('.overlay').click(function () {
    $('.dropdown').removeClass('active')
    $('.nav-item').removeClass('active')
    $('.overlay').removeClass('d-block')
})
